<div class="description">
  <div class="project-description">
    <div class="project-description__section">
      <div class="project-description__title">{{ 'PROJECT.describe_your_work' | translate }}</div>
      <app-ph-input
        [placeholder]="'PROJECT.q1' | translate"
        [validation]="'textarealongtext'"
        [correctForm]="correctForm"
        type="textarea"
        name="description_one"
      ></app-ph-input>
      <app-ph-input
        [placeholder]="'PROJECT.q2' | translate"
        [validation]="'textarealongtext'"
        [correctForm]="correctForm"
        type="textarea"
        name="description_two"
      ></app-ph-input>
      <app-ph-input
        [placeholder]="'PROJECT.q3' | translate"
        [validation]="'textarealongtext'"
        [correctForm]="correctForm"
        type="textarea"
        name="description_three"
      ></app-ph-input>
      <app-ph-input
        [placeholder]="'PROJECT.q4' | translate"
        [validation]="'textarealongtext'"
        [correctForm]="correctForm"
        type="textarea"
        name="description_four"
      ></app-ph-input>
    </div>
    <div class="project-description__section">
      <div class="project-description__title">{{ 'PROJECT.video_link' | translate }}</div>
      <app-ph-input
        [placeholder]="'PROJECT.paste_url' | translate"
        type="text"
        [correctForm]="correctForm"
        (phInputChange)="correctVideoLink()"
        [validation]="'urlnotrequired'"
        [disabled]="videoLoading"
        name="video"
      ></app-ph-input>
      <div *ngIf="correctVideoLinkSanitizer" class="project-description__section--show-video">
        <iframe [src]="correctVideoLinkSanitizer" width="100%"></iframe>
      </div>
    </div>
    <div
      class="project-description__section"
      #bagsSection
      [ngClass]="{ 'project-bags--error': bags.invalid }"
    >
      <div class="project-description__title">
        <span class="trash-title" [innerHTML]="'PROJECT.how_much_trash' | translate"></span>
        <button class="btn btn--link" (click)="displayBagCounter = true">
          {{ 'PROJECT.how_much_trash_info' | translate }}
        </button>
      </div>
      <div
        class="project-description__content"
        [ngClass]="{ 'not-added-bags': !notAddedBags && bags.length === 0 }"
      >
        <div class="project-description__content-item">
          <app-ph-input
            [placeholder]="'PROJECT.type_of_trash' | translate"
            [validation]="'required'"
            type="select"
            name="type"
            bindLabel="name"
            [searchable]="false"
            [selectArray]="currentBagsSelect"
            [correctForm]="formTrash"
            [ngClass]="{ 'validation-ok': bags.length > 0 }"
            (phInputChange)="updateGarbageBagsSelect($event)"
          ></app-ph-input>
        </div>
        <div class="project-description__content-item">
          <!--   don't touch name (interface Bags) -->
          <app-ph-input
            [placeholder]="'PROJECT.garbage_bags' | translate"
            [validation]="'required'"
            type="select"
            name="bags"
            bindLabel="value"
            [selectCustomTagOption]="checkNumberLengthRef"
            [selectArray]="garbage"
            [ngClass]="{ 'validation-ok': bags.length > 0 }"
            [correctForm]="formTrash"
          ></app-ph-input>
        </div>
      </div>
      <button
        class="btn btn--outline btn--primary btn--md"
        [disabled]="loading || formTrash.invalid"
        (click)="addTrash()"
      >
        {{ 'PROJECT.add' | translate }}
      </button>
      <div class="project-description__separator"></div>
      <div class="project-description__content" *ngIf="bags.length">
        <ul>
          <li class="project-description__content" *ngFor="let item of bags.value; let i = index">
            <div class="trash-amount has__icon">
              <div class="trash-amount__icon">
                <img [src]="'assets/img/icons/' + item.type + '.svg'" />
              </div>
              <div class="trash-amount__title">{{ 'PROJECT.type_of_trash' | translate }}</div>
              <div class="trash-amount__value">
                {{ 'PROJECT.GARBAGE_TYPE.' + item.type | translate }}
              </div>
            </div>
            <div class="trash-amount">
              <div class="trash-amount__title">{{ 'PROJECT.garbage_bags' | translate }}</div>
              <div class="trash-amount__value">{{ item.count }}</div>
              <button class="trash-amount__remove" [disabled]="loading" (click)="deleteTrash(i)">
                <img src="assets/img/close.svg" [alt]="'PROJECT.remove' | translate" />
              </button>
            </div>
          </li>
        </ul>
      </div>
      <div class="project-description__content" *ngIf="editMode && editProject.from_event">
        <div
          class="project-description__content-item"
          *ngIf="editMode && editProject.from_event && isFromEcoHeroesEvent()"
        >
          <div class="project-description__title">
            {{ 'PROJECT.number_of_workers' | translate }}
          </div>
          <app-ph-input
            [placeholder]="'EVENT.workers_count' | translate"
            [validation]="'required'"
            type="number"
            name="participant_guest"
            [showRequired]="true"
            [correctForm]="correctForm"
          ></app-ph-input>
        </div>
        <div class="project-description__content-item">
          <div class="project-description__title">
            {{
              (isFromEcoHeroesEvent() ? 'PROJECT.how_many_guest' : 'PROJECT.how_many_participants')
                | translate
            }}
          </div>
          <app-ph-input
            [placeholder]="'EVENT.participants_count' | translate"
            [validation]="'required'"
            type="number"
            name="participant_counter"
            [showRequired]="true"
            [correctForm]="correctForm"
          ></app-ph-input>
        </div>
        <div class="project-description__separator"></div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="displayBagCounter"
  [dismissableMask]="true"
  [modal]="true"
  (onHide)="displayBagCounter = false"
>
  <div style="padding: 40px 40px">
    <div class="modal__wrapper modal__wrapper--xlg">
      <div class="photos-helper">
        <div class="photos-helper__title">{{ 'PROJECT.helper_title' | translate }}</div>
        <div class="photos-helper__content">
          <!-- <div class="photos-helper__description ">
              {{ 'WALLET.image_front_helper_description' | translate }}
            </div> -->

          <div class="instruction__wrapper">
            <div class="instruction__row">
              <div class="image">
                <img
                  style="height: 70px; max-width: 100%"
                  src="assets/img/helpers/bag-60.svg"
                  alt=""
                />
              </div>
              <div class="description" [innerHTML]="'PROJECT.helper_bag_60' | translate"></div>
            </div>
            <div class="instruction__row">
              <div class="image">
                <img
                  style="height: 70px; max-width: 100%"
                  src="assets/img/helpers/Bag-120.svg"
                  alt=""
                />
              </div>
              <div class="description" [innerHTML]="'PROJECT.helper_bag_120' | translate"></div>
            </div>

            <div class="instruction__row">
              <div class="image">
                <img
                  style="height: 70px; max-width: 100%"
                  src="assets/img/helpers/Tyre.svg"
                  alt=""
                />
              </div>
              <div class="description" [innerHTML]="'PROJECT.helper_tyre' | translate"></div>
            </div>
            <div class="instruction__row">
              <div class="image">
                <img
                  style="height: 70px; max-width: 100%"
                  src="assets/img/helpers/Bulky.svg"
                  alt=""
                />
              </div>
              <div class="description" [innerHTML]="'PROJECT.helper_bag_bulky' | translate"></div>
            </div>
          </div>
          <div class="instruction__additional__info">
            <div [innerHTML]="'PROJECT.helper_legend' | translate"></div>
            <div [innerHTML]="'PROJECT.helper_additional_info' | translate"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal__actions">
      <button
        class="btn btn--outline btn--primary btn--xs btn--rounded"
        (click)="displayBagCounter = false"
      >
        {{ 'GLOBAL.ok' | translate }}
      </button>
    </div>
  </div>
</p-dialog>
